<template>
  <div id="app">
    <div class="bg">
      <transition
        name="fade-transform"
        mode="out-in"
      >
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>
<script>
export default {

}
</script>
<style lang="scss" scoped>
#app {
  height: 100%;
}
.bg {
  height: 100%;
  background-image: url('~@/assets/image/bg.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  padding: 60px 20px 48px;
  min-width: 1300px;
  min-height: 700px;
}
</style>
